import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedDate } from 'react-intl';

import { media } from '../../../styles/style-utils';
import { legacyType } from '../../../styles/typography';
import Modal from '../../common/Modal';

const ModalWrapper = styled.div`
  padding: 5rem var(--default-horizontal-padding) 0 var(--default-horizontal-padding);
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
`;

const List = styled.ul`
  ${media.mediumLarge`
    padding: 0 2rem;
  `};
`;

const Item = styled.li`
  list-style: none;
  padding: 2rem 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  text-align: left;
  position: relative;

  > :not(:last-child) {
    margin-bottom: 2rem;
  }

  ${media.mediumLarge`
    flex-direction: row;

    > :not(:last-child) {
      margin-bottom: 0;
    }
  `};

  &:not(:last-child) {
    border-bottom: calc(var(--fr) * 0.0625) solid var(--c-white);
  }
`;

const Date = styled.div`
  font-size: var(--fs-m);
  flex: 1 1 20%;

  .year {
    ${legacyType('m', 'body')};
  }

  .date {
    font-weight: 500;
  }
`;

const Title = styled.div`
  flex: 1 1 80%;
  font-size: var(--fs-sm);
  ${legacyType('sm', 'body')};

  .subtitle {
    text-transform: uppercase;
    ${legacyType('s', 'label', { uppercase: true })};
    font-size: var(--fs-s);
  }
`;

const View = styled.div`
  flex: 1 1 20%;
  text-decoration: underline;
  font-size: var(--fs-s);
  color: var(--c-red);
  ${legacyType('s', 'label')};

  ${media.mediumLarge`
    text-align: right;
    margin: auto;
  `}
`;

const PressList = props => {
  const { data, isOpen, onClose } = props;
  const { type, year, pressList } = data;

  const listToComponents = (item, index) => {
    const { date, link, title, subtitle } = item;
    return (
      <Item key={index}>
        {link && (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="dummy-btn"
            aria-label={title}
          />
        )}
        <Date>
          <div className="date">
            <FormattedDate month="short" day="numeric" value={date} />
          </div>
          <div className="year">
            <FormattedDate year="numeric" value={date} />
          </div>
        </Date>
        <Title>
          <div className="subtitle">{subtitle}</div>
          <div>{title}</div>
        </Title>
        <View>{link && <FormattedMessage defaultMessage="View" id="press.view" />}</View>
      </Item>
    );
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalWrapper>
        <h1>
          {year}&nbsp;
          {type}
        </h1>
        <List>{pressList.map(listToComponents)}</List>
      </ModalWrapper>
    </Modal>
  );
};

PressList.propTypes = {
  data: PropTypes.object,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default PressList;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/press/PressList.js